import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
    projectId: 'zs3g2yg8',
    dataset: 'production',
    useCdn: true, // set to `true` to use the edge cache (apicdn.sanity.io) which might bypass some blockers
    apiVersion: '2023-05-03', // use current date (YYYY-MM-DD) to target the latest API version
    token: undefined, // Explicitly no token for frontend client
    ignoreBrowserTokenWarning: true
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => {
    return builder.image(source);
};

// Persistent Cache using localStorage
const CACHE_PREFIX = 'sanity_cache_';
const CACHE_EXPIRY = 1000 * 60 * 2; // 2 minutes (Reduced from 1 hour to ensure fresh content)

export const fetchWithCache = async (query, params = {}) => {
    const key = CACHE_PREFIX + JSON.stringify({ query, params });

    // Check Local Storage
    try {
        const cached = localStorage.getItem(key);
        if (cached) {
            const { data, timestamp } = JSON.parse(cached);
            if (Date.now() - timestamp < CACHE_EXPIRY) {
                console.log(`[CACHE HIT] ${query.slice(0, 50)}...`);
                return data;
            }
        }
    } catch (e) {
        console.warn('[Sanity] Cache read failed:', e);
    }

    console.log(`[API FETCH] ${query.slice(0, 50)}...`);
    try {
        const result = await client.fetch(query, params);

        // Save to Local Storage
        try {
            localStorage.setItem(key, JSON.stringify({
                data: result,
                timestamp: Date.now()
            }));
        } catch (e) {
            console.warn('[Sanity] Cache storage failed (quota exceeded?):', e);
        }

        return result;
    } catch (error) {
        console.error("[Sanity] Fetch error:", {
            message: error.message,
            query: query,
            params: params,
            error: error
        });
        throw error;
    }
};
